/**
 * Shared sx helpers that follow the active MUI theme (primary, divider, etc.).
 * Use on Buttons with color="primary" | "secondary" — avoid hardcoded hex colors.
 */

/** Contained primary action — use with <Button variant="contained" color="primary" sx={containedPrimaryBtnSx} /> */
export const containedPrimaryBtnSx = {
  fontWeight: 600,
  textTransform: 'none',
};

/** Outlined primary action */
export const outlinedPrimaryBtnSx = {
  fontWeight: 600,
  textTransform: 'none',
  borderColor: 'primary.main',
  color: 'primary.main',
  '&:hover': {
    borderColor: 'primary.dark',
    bgcolor: 'action.hover',
  },
};

export const dialogPaperSx = {
  '& .MuiDialog-paper': {
    borderRadius: 2,
    boxShadow: (theme) =>
      theme.palette.mode === 'dark'
        ? '0 8px 32px rgba(0,0,0,0.45)'
        : '0 4px 20px rgba(15,23,42,0.12)',
    p: 2,
  },
};

export const dialogTitleSx = {
  fontSize: '1.5rem',
  fontWeight: 600,
  color: 'primary.main',
  pb: 1,
  borderBottom: '1px solid',
  borderColor: 'divider',
};

export const dialogSecondaryBtnSx = {
  borderColor: 'divider',
  color: 'text.primary',
  '&:hover': { borderColor: 'text.secondary', bgcolor: 'action.hover' },
};
